import api from '@pray/shared/utils/api';

import type { RegenerateSlideResponse } from './data/response';
import type { RegenerateSlideRequest } from './data/types';

type RegenerateSlideProps = {
  artistId: string;
  reportId: string;
  slideId: string;
  data?: RegenerateSlideRequest;
};

export async function regenerateSlide({
  artistId,
  reportId,
  slideId,
  data = {},
}: RegenerateSlideProps): Promise<RegenerateSlideResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!reportId) throw new Error('Report ID is required');
  if (!slideId) throw new Error('Slide ID is required');

  const url = `/web/studio/artists/${artistId}/reports/${reportId}/slides/${slideId}/regenerate`;

  const response = await api.executePostRequest<RegenerateSlideResponse>(url, data);
  return response.data;
}
